import { TenantEnvironment } from '@experiences/interfaces';

/**
 * Utility function to get the enum key from the enum value
 * @param value - The enum value (e.g., 'NonProduction')
 * @returns The enum key (e.g., 'Staging') or the value itself if not found
 */
export const getTenantEnvironmentKey = (value: string): keyof typeof TenantEnvironment => {
    const entry = Object.entries(TenantEnvironment).find(([ _, enumValue ]) => enumValue === value);
    return entry ? entry[0] as keyof typeof TenantEnvironment : value as keyof typeof TenantEnvironment;
};
